import storage from './storage';

const STORAGE_KEY = 'cachedPac';

function load() {
  try {
    const PAC = JSON.parse(storage.local.getItem(STORAGE_KEY));

    if (PAC && PAC.model) {
      return PAC;
    }
  } catch (err) {
    console.error(err);
  }

  storage.local.removeItem(STORAGE_KEY);

  return null;
}

function save(PAC) {
  storage.local.setItem(STORAGE_KEY, JSON.stringify(PAC));
}

function clear() {
  storage.local.clear();
}

export default {
  load,
  save,
  clear,
};
